import React, { useState } from "react";
import { Dimensions, View, TouchableOpacity } from 'react-native';
import Typography from "../typography/Typography";
import { ColorTokens, IconSizeTokens, IconTokens, TypographyTypeDLS } from "@voltmoney/schema";
import BottomSheet from "./BottomSheet";
import { ModalAlignmentEnum, OpenNewTabTargetType } from "@voltmoney/types";
import { SCREEN_SIZE, isMobile, isMobileView } from "../stack/utils";
import { getScreenType, openNewTabDC } from "./utils";
import Icon from "../icon/Icon";
export var DeepLinks;
(function (DeepLinks) {
    DeepLinks["MOBILE_WHATSAPP"] = "whatsapp://send?phone=";
    DeepLinks["WHATSAPP"] = "https://wa.me/";
    DeepLinks["CALL"] = "tel:";
    DeepLinks["MAILTO"] = "mailto:";
})(DeepLinks || (DeepLinks = {}));
export var ContactType;
(function (ContactType) {
    ContactType["WHATSAPP"] = "WHATSAPP";
    ContactType["CALL"] = "CALL";
    ContactType["EMAIL"] = "EMAIL";
})(ContactType || (ContactType = {}));
const ContactCard = ({ id, customTitle, customSubTitle, title, leadIconName, contactNumber, isFromPhonePe, type, }) => {
    const isIframe = () => {
        return window.self !== window.top;
    };
    const handlePress = (type) => {
        const screenType = getScreenType(Dimensions.get('window').width);
        if (type === ContactType.WHATSAPP) {
            if (isFromPhonePe) {
                openNewTabDC(`whatsapp://send?phone=+919611749097&text=Hi`, OpenNewTabTargetType.parent);
            }
            else {
                if (isIframe()) {
                    openNewTabDC(DeepLinks.WHATSAPP + contactNumber, OpenNewTabTargetType.blank);
                }
                else if (screenType === SCREEN_SIZE.X_SMALL ||
                    screenType === SCREEN_SIZE.SMALL) {
                    openNewTabDC(DeepLinks.MOBILE_WHATSAPP + contactNumber, OpenNewTabTargetType.parent);
                }
                else {
                    openNewTabDC(DeepLinks.WHATSAPP + contactNumber, OpenNewTabTargetType.blank);
                }
            }
        }
        else if (type === ContactType.CALL) {
            openNewTabDC(DeepLinks.CALL + contactNumber, OpenNewTabTargetType.parent);
        }
        else if (type === ContactType.EMAIL) {
            openNewTabDC(DeepLinks.MAILTO + contactNumber, OpenNewTabTargetType.parent);
        }
    };
    return (React.createElement(TouchableOpacity, { activeOpacity: 0.5, onPress: () => {
            handlePress(type);
        }, style: {
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            padding: 16,
            borderWidth: 1,
            borderRadius: 12,
            backgroundColor: '#FAFBFE',
            borderColor: '#D0D6F5'
        } },
        React.createElement(View, { style: {
                borderRadius: 20,
                width: 40,
                height: 40,
                justifyContent: 'center',
                alignItems: 'center',
                backgroundColor: ColorTokens.Primary_05,
            } },
            React.createElement(Icon, { name: leadIconName, color: ColorTokens.Primary_100, size: IconSizeTokens.XXL })),
        React.createElement(View, { style: { flexShrink: 1, marginHorizontal: 12 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1S, label: title, color: ColorTokens.Grey_Night }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: customSubTitle, color: ColorTokens.Grey_Charcoal })),
        React.createElement(Icon, { name: IconTokens.ChervonDownRight, size: IconSizeTokens.XXXL, color: ColorTokens.Primary_100 })));
};
const NeedHelpDC = ({ showNeedHelp, setShowNeedHelp, contactUsDetails, isFromJupiter, }) => {
    const [modalHeight] = useState(isMobileView() ? (isFromJupiter || !contactUsDetails?.showSupportPhoneNumber) ? 350 : 452 : (isFromJupiter || !contactUsDetails?.showSupportPhoneNumber) ? 350 : 436);
    const modalContentPresenter = () => {
        return (React.createElement(TouchableOpacity, { activeOpacity: 1, style: { padding: 16, marginTop: 8 } },
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: "Reach out to us", color: ColorTokens.Grey_Night }),
            React.createElement(View, { style: { marginTop: 8 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: isFromJupiter ? "We would love to hear from you. You can reach us via Call or Email." : !contactUsDetails?.showSupportPhoneNumber ? "We would love to hear from you. You can reach us via WhatsApp or Email." : "We would love to hear from you. You can reach us via WhatsApp, Call or Email.", color: ColorTokens.Grey_Charcoal })),
            React.createElement(View, { style: { marginTop: 24 } },
                isFromJupiter ? React.createElement(React.Fragment, null, " ") : React.createElement(ContactCard, { id: 'txt_contactUs_whatsApp', customTitle: 'WhatsApp', customSubTitle: 'We usually reply within 5-10 mins. We\u2019re available on Mon-Sat from 9:30 AM to 6:30 PM', title: 'WhatsApp', leadIconName: IconTokens.Whatsapp, contactNumber: contactUsDetails?.whatsappNumber, isFromPhonePe: contactUsDetails?.isFromPhonePe, type: ContactType.WHATSAPP }),
                contactUsDetails?.showSupportPhoneNumber && React.createElement(View, { style: { marginTop: isFromJupiter ? 0 : 16 } },
                    React.createElement(ContactCard, { id: 'txt_contactUs_call', customTitle: 'Call', customSubTitle: isFromJupiter ? `Call us at +918655055086. We’re available on Mon-Sat from 9:30 AM to 6:30 PM` : `Call us at ${contactUsDetails?.callNumber}. We’re available on Mon-Sat from 9:30 AM to 6:30 PM`, title: 'Call', leadIconName: IconTokens.Phone, contactNumber: contactUsDetails?.callNumber, isFromPhonePe: contactUsDetails?.isFromPhonePe, type: ContactType.CALL })),
                React.createElement(View, { style: { marginTop: 16 } },
                    React.createElement(ContactCard, { id: 'txt_contactUs_email', customTitle: 'Email', customSubTitle: isFromJupiter ? `Email us at support@jupiter.money. We usually respond within 2 hours` : `Email us at ${contactUsDetails?.email}. We usually respond within 2 hours`, title: 'Email', leadIconName: IconTokens.Email, contactNumber: contactUsDetails?.email, isFromPhonePe: contactUsDetails?.isFromPhonePe, type: ContactType.EMAIL })))));
    };
    return showNeedHelp ? (React.createElement(View, { style: {
            position: 'absolute',
            bottom: 0,
            zIndex: 99
        } },
        React.createElement(BottomSheet, { autoAdjustHeight: false, height: modalHeight, width: '100%', closeFunction: () => {
                setShowNeedHelp(false);
            }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: Dimensions.get('window').height, screenWidth: isMobile(getScreenType(Dimensions.get('window').width)) ? Dimensions.get('window').width : 508, routeId: "routeId", handleKeyboard: false }, modalContentPresenter()))) : React.createElement(React.Fragment, null);
};
export default NeedHelpDC;
